import styled from '@emotion/styled';
import { Skeleton } from 'src/components-dummy/Skeleton';

export const StyledSkeleton = styled(Skeleton)`
  margin: 10px;
`;
